import { TrackToolService } from '@analytics/events';
import { AnalyticsActionTypes } from '@analytics/models';
import { Injectable, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap, withLatestFrom } from 'rxjs/operators';

import { trackStep } from './how-to-questionnaire.actions';
import { getFlattenedChoices } from './how-to-questionnaire.selectors';

@Injectable()
export class HowToQuestionnaireEffects {
  private readonly choices$ = this.store$.select(getFlattenedChoices);

  constructor(
    private readonly actions$: Actions,
    private readonly store$: Store<any>,
    private readonly injector: Injector
  ) {}

  public trackStepEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(trackStep),
        withLatestFrom(this.choices$),
        tap(([{ trackingValues }, choices]) => {
          /**
           * WTA-17: resolve injector context
           */
          const trackToolService = this.injector.get(TrackToolService);
          const extraProperties =
            trackingValues?.type === AnalyticsActionTypes.LAST_STEP
              ? { result: choices }
              : undefined;
          trackToolService.trackTool(trackingValues, extraProperties);
        })
      ),
    { dispatch: false }
  );
}
